import { downloadBlobFromApi } from '../../helpers'
import apiService from '../Api'
import { ISurveyFilters, ISurveyListItem, ISurveyReport, ISurveyResponsesPage, TSurveyScope } from './types'

/** Descarta filtro vazio: sem isso o backend recebe 'course_id=' e trata como filtro preenchido. */
const buildParams = (filters: Partial<ISurveyFilters>): Record<string, string> =>
  Object.entries(filters).reduce<Record<string, string>>((params, [key, value]) => {
    if (value) params[key] = value

    return params
  }, {})

export class SurveyService {
  async list(): Promise<{ total: number; data: ISurveyListItem[] }> {
    return apiService.get('/surveys').then((response) => response.data)
  }

  async report(id: TSurveyScope, filters: Partial<ISurveyFilters> = {}): Promise<ISurveyReport> {
    return apiService.get(`/surveys/${id}/report`, { params: buildParams(filters) }).then((response) => response.data)
  }

  async responses(
    id: TSurveyScope,
    params: Partial<ISurveyFilters> & { page: number; page_size: number }
  ): Promise<ISurveyResponsesPage> {
    const { page, page_size, ...filters } = params

    return apiService
      .get(`/surveys/${id}/responses`, { params: { ...buildParams(filters), page, page_size } })
      .then((response) => response.data)
  }

  async deleteResponse(id: number): Promise<{ message: string }> {
    return apiService.delete(`/surveys/responses/${id}`).then((response) => response.data)
  }

  async exportXlsx(id: TSurveyScope, filters: Partial<ISurveyFilters>, slug: string): Promise<void> {
    // downloadBlobFromApi usa o axios central, mas não repassa `params` — por isso a query
    // dos filtros vai montada na própria URL.
    const query = new URLSearchParams(buildParams(filters)).toString()

    return downloadBlobFromApi(
      `/surveys/${id}/responses/export-xlsx${query ? `?${query}` : ''}`,
      `pesquisa_${slug}_respostas.xlsx`
    )
  }
}
